import { useEffect, useState } from 'react';
import { Buildings } from '@phosphor-icons/react';
import { officeBrandTheme, safeOfficeLogo } from './office-brand.js';
import './connected-office-brand.css';
import { N9Attribution } from './N9Attribution.jsx';
import {PlanBadge} from './ProgramFeatures.jsx';

export function useConnectedOfficeBrand(identityOffice, allowPublic = true) {
  const requested = new URLSearchParams(window.location.search).get('office') || '';
  const slug = identityOffice?.slug || (allowPublic ? requested : '');
  const [loaded,setLoaded] = useState(null);
  useEffect(()=>{
    if (!/^[a-z][a-z0-9-]{2,47}$/.test(slug)) return;
    let active=true;
    let pending=false;
    let controller;
    const refresh=async()=>{
      if(pending || document.visibilityState==='hidden') return;
      pending=true;
      controller=new AbortController();
      const timer=setTimeout(()=>controller.abort(),6000);
      try {
        const response=await fetch(`/api/v1/public/offices/${slug}`,{cache:'no-store',signal:controller.signal});
        if(response.ok) {const payload=await response.json();if(active)setLoaded(payload.office);}
      } catch { /* Keep the last confirmed office during transient outages. */ }
      finally {clearTimeout(timer);pending=false;}
    };
    refresh();
    window.addEventListener('focus',refresh);
    document.addEventListener('visibilitychange',refresh);
    return()=>{active=false;controller?.abort();window.removeEventListener('focus',refresh);document.removeEventListener('visibilitychange',refresh);};
  },[slug]);
  return loaded?.slug===slug ? loaded : identityOffice || null;
}

export function connectedOfficeTheme(office) {
  if(!office) return undefined;
  const theme=officeBrandTheme(office);
  return {...theme,'--green':theme['--office-accent'],'--green-strong':theme['--accent-strong'],
    '--green-soft':theme['--accent-soft'],'--execution-accent':theme['--office-accent'],
    '--execution-accent-strong':theme['--accent-strong']};
}

export function ConnectedOfficeBrand({office,product}) {
  const logo=safeOfficeLogo(office?.logo_url);
  const [failed,setFailed]=useState(false);
  useEffect(()=>setFailed(false),[logo]);
  return <div className="connected-office-brand" aria-label={`${office.name} · ${product}`}>
    <span className="connected-office-mark">{logo&&!failed?<img src={logo} alt="" referrerPolicy="no-referrer" onError={()=>setFailed(true)}/>:<Buildings size={28}/>}</span>
    <span className="connected-office-name"><strong>{office.name}</strong><span className="connected-office-product"><small>{product}</small><PlanBadge subscription={office.subscription}/></span><small className="connected-office-credit"><N9Attribution/></small></span>
  </div>;
}
